import React from 'react';
import { CircleCharIconView } from './view';
import { styles } from './styles';

export class CircleCharIcon extends React.Component {
  render() {
    return <CircleCharIconView {...this.props} styles={styles} />;
  }
}
